import * as React from 'react';

export const ChangeRequestsScreen = React.lazy(() => import('./ChangeRequestsScreen.lazy'));
